export const VEHICLE_CATALOG = {
  Acura: ["Integra", "MDX", "RDX", "TLX"],
  Audi: ["A3", "A4", "A5", "A6", "Q3", "Q5", "Q7", "Q8"],
  BMW: [
    "2 Series",
    "3 Series",
    "4 Series",
    "5 Series",
    "7 Series",
    "X1",
    "X3",
    "X4",
    "X5",
    "X6",
    "X7",
  ],
  Buick: ["Enclave", "Encore", "Envision"],
  Cadillac: ["CT4", "CT5", "Escalade", "XT4", "XT5", "XT6"],
  Chevrolet: [
    "Blazer",
    "Camaro",
    "Equinox",
    "Malibu",
    "Silverado",
    "Suburban",
    "Tahoe",
    "Traverse",
    "Trax",
  ],
  Chrysler: ["300", "Pacifica", "Town & Country"],
  Dodge: ["Challenger", "Charger", "Durango", "Grand Caravan", "Hornet"],
  Ford: [
    "Bronco",
    "Edge",
    "Escape",
    "Explorer",
    "F-150",
    "Maverick",
    "Mustang",
    "Ranger",
  ],
  Genesis: ["G70", "G80", "G90", "GV70", "GV80"],
  GMC: ["Acadia", "Canyon", "Sierra", "Terrain", "Yukon"],
  Honda: [
    "Accord",
    "Civic",
    "CR-V",
    "HR-V",
    "Odyssey",
    "Passport",
    "Pilot",
    "Ridgeline",
  ],
  Hyundai: [
    "Elantra",
    "Kona",
    "Palisade",
    "Santa Fe",
    "Sonata",
    "Tucson",
    "Venue",
  ],
  Infiniti: ["Q50", "Q60", "QX50", "QX55", "QX60", "QX80"],
  Jeep: [
    "Cherokee",
    "Compass",
    "Gladiator",
    "Grand Cherokee",
    "Renegade",
    "Wrangler",
  ],
  Kia: [
    "Carnival",
    "Forte",
    "K5",
    "Seltos",
    "Sorento",
    "Soul",
    "Sportage",
    "Telluride",
  ],
  "Land Rover": [
    "Defender",
    "Discovery",
    "Range Rover",
    "Range Rover Evoque",
    "Range Rover Sport",
  ],
  Lexus: ["ES", "GX", "IS", "LS", "LX", "NX", "RC", "RX", "UX"],
  Lincoln: ["Aviator", "Corsair", "Nautilus", "Navigator"],
  Mazda: ["CX-30", "CX-5", "CX-50", "CX-9", "CX-90", "Mazda3"],
  "Mercedes-Benz": [
    "C-Class",
    "CLA",
    "E-Class",
    "GLA",
    "GLB",
    "GLC",
    "GLE",
    "GLS",
    "S-Class",
  ],
  MINI: ["Clubman", "Convertible", "Cooper", "Countryman"],
  Mitsubishi: ["Eclipse Cross", "Mirage", "Outlander", "Outlander Sport"],
  Nissan: [
    "Altima",
    "Armada",
    "Frontier",
    "Kicks",
    "Maxima",
    "Murano",
    "Pathfinder",
    "Rogue",
    "Sentra",
    "Versa",
  ],
  Porsche: ["718", "911", "Cayenne", "Macan", "Panamera", "Taycan"],
  Ram: ["1500", "2500", "3500", "ProMaster"],
  Subaru: [
    "Ascent",
    "Crosstrek",
    "Forester",
    "Impreza",
    "Legacy",
    "Outback",
    "WRX",
  ],
  Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
  Toyota: [
    "4Runner",
    "Camry",
    "Corolla",
    "Grand Highlander",
    "Highlander",
    "Prius",
    "RAV4",
    "Sequoia",
    "Sienna",
    "Tacoma",
    "Tundra",
    "Venza",
  ],
  Volkswagen: ["Atlas", "Golf", "Jetta", "Taos", "Tiguan"],
  Volvo: ["S60", "S90", "V60", "XC40", "XC60", "XC90"],
} as const;

export const VEHICLE_MAKES = Object.keys(VEHICLE_CATALOG).sort((a, b) =>
  a.localeCompare(b),
);

export function modelsForMake(make: string): readonly string[] {
  const normalized = VEHICLE_MAKES.find(
    (candidate) => candidate.toLowerCase() === make.trim().toLowerCase(),
  );
  return normalized
    ? VEHICLE_CATALOG[normalized as keyof typeof VEHICLE_CATALOG]
    : [];
}
